/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ArrowBackIosNew } from '@mui/icons-material';
import { AUDIO, VIDEO } from 'Constants/General';
import useTranslation from 'Hooks/useTranslation';
import Module from './Components/Module';
import useLesson from './Hooks/useLesson';
import {
  Header,
  BackContainer,
  Main,
  LessonContainer,
  VideoContainer,
  VideoInfo,
  VideoTitle,
  SideBar,
  videoStyle,
  audioStyle,
  courseTitle,
  authorStyle,
} from './style';

export default function Lessons() {
  const location = useLocation();
  const history = useHistory();
  const { t2 } = useTranslation('Generic');

  const { lesson, modules, course } = location?.state || {};
  const [selectedLesson, setSelectedLesson] = useState(lesson);

  const { contentUrl } = useLesson({ selectedLesson });

  let shownContent;
  if (selectedLesson.LessonType.name === VIDEO) {
    shownContent = <video autoPlay controls src={contentUrl} style={videoStyle} />;
  }
  if (selectedLesson.LessonType.name === AUDIO) {
    shownContent = <audio controls src={contentUrl} style={audioStyle} />;
  }

  return (
    <>
      <Header>
        <BackContainer onClick={history.goBack}>
          <ArrowBackIosNew />
          {t2('Back')}
        </BackContainer>
        <div style={courseTitle}>{course?.name}</div>
      </Header>
      <Main>
        <LessonContainer>
          <VideoContainer>{shownContent}</VideoContainer>
          <VideoInfo>
            <VideoTitle>{selectedLesson.name}</VideoTitle>
            <div style={authorStyle}>
              {t2('By')} {course?.creatorName}
            </div>
          </VideoInfo>
        </LessonContainer>
        <SideBar>
          {modules.map(module => (
            <Module
              key={module.id}
              id={module.id}
              title={module.name}
              lessons={module.lessons}
              selectedLesson={selectedLesson}
              callback={setSelectedLesson}
            />
          ))}
        </SideBar>
      </Main>
    </>
  );
}
